import { cloneDeep } from 'lodash';

export const assignProperties = <T>(obj: T, src: Partial<T> = {}): T => {
  const clonedObj = cloneDeep(obj) as any; // fixme

  // Initial properties cannot be 'undefined' because they are required
  for (const [key, value] of Object.entries(src)) {
    if (clonedObj[key] !== undefined && value === undefined) continue;

    clonedObj[key] = value;
  }

  return clonedObj;
};

export type Unboxed<T> = NonNullable<T> extends (infer U)[] ? U : never;
